import React from "react";
import { InputText } from "primereact/inputtext";
import "./Header.scss";
import { IoIosNotifications } from "react-icons/io";
import { FaChevronDown } from "react-icons/fa6";
import { CiSearch } from "react-icons/ci";
import Logo from "./logo/Logo";

export default function Header() {
  return (
    <header>
      <Logo></Logo>
      {/* <img src="/assets/images/peerislands-logo.png" alt="logo" /> */}
      {/* <div className="logo">{logo}</div>s */}
      <div className="header-search-bar">
        <CiSearch />
        <InputText placeholder="search..." />
      </div>
      <div className="end-header">
        <div className="notification">
          {" "}
          <IoIosNotifications />
        </div>
        <img src="/assets/images/vector-profile.png" alt="profile" />
        <label>Rajesh</label>
        <FaChevronDown />
      </div>
    </header>
  );
}
